import React from 'react';
import PropTypes from 'prop-types';
import immutable from 'immutable';

import urlMapping from '../app/URLMapping';
import {sendToExtension} from '../app/ExtensionCommunicate';
import Token from '../../../packages/extension/src/background/Token';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import LoggedOutMessage from './LoggedOutMessage.react';
import {displayError} from '../app/errorDisplayer';

import './Panels.scss';

export function sendMessage(msg) {
    let target = parent.postMessage ? parent : (parent.document.postMessage ? parent.document : undefined);
    // target.postMessage(msg, "*");
}

let lastPanelControllerInstance = null;
let defaultPanelHeight = 98;
let defaultMiniPanelHeight = 78;

interface EmbededPanelControllerProps {
    children?: React.ReactNode;
    location?: object;
}

export default class EmbededPanelController extends React.Component<EmbededPanelControllerProps> {

    static propTypes = {
        children: PropTypes.node,
        location: PropTypes.object,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    static childContextTypes = {
        embededPanelController: PropTypes.object,
        screenInfo: PropTypes.object,
        screenOperation: PropTypes.string,
    };

    getChildContext() {
        return {
            screenInfo: this.state.screenInfo,
            screenOperation: this.state.action,
            embededPanelController: lastPanelControllerInstance,
        };
    }

    constructor(props) {
        super(props);

		let config = window['config'] || {};

        this.isOpen = !Boolean(config['isSmall']);
        this.fullscreen = false;
		this.tooltip = false;

        this.state = {
            parsed: null,
            isReloading: true,
            url: null,
            haveScreenData: false,
            orientation: config['orientation'] ? config['orientation'] : 'horizontal',
            isInjected: Boolean(config['isInjected']),
			parentWinHeight: 0,
			panelHeight: 0,
			initialized: false,
			app: null,
			loggedOut: false,
			screenId: config.screenId
        };

		this.setMinimalized(Boolean(config.minimalized), config.screenId);

        lastPanelControllerInstance = this; // eslint-disable-line consistent-this
    }

    isInjected() {
        return window['config']['isInjected'] && window['config']['isInjected'] === 'true' ? true : false;
    }

    checkToken() {
        if (!Token.get() || Token.isExpired()) {
            this.setState({
                isReloading: false,
            });

            let path = urlMapping.getUrl("panel", "not-logged", this.getURLObject());
            this.context.router.push(path);

            return false;
        } else {
            return true;
        }
    }

    getURLObject(state) {
		state = state || this.state;
        let d = { ...state.screenInfo };
        let data = state.parsed;

        if (!data) {
            data = {};
        }

        d['data'] = encodeURIComponent(JSON.stringify(data)).replace("/", "%2F");

        return d;
    }

    getLastURL() {
        return this.state.url;
    }

    getOrganisationId() {
        return this.state.organisation_id;
    }

	getPathInfo(serverResponse) {
		let pathInfo = this.getURLObject();
		pathInfo.organisation_id = serverResponse.data.organisation_id;
		pathInfo.channel_id = serverResponse.data.channel_id;
		pathInfo.channelDef_id = serverResponse.data.channelDef_id;
		pathInfo.channelMappingDef_id = serverResponse.data.id;
		pathInfo.cachingChannel_id = serverResponse.cachingChannel_id;

		return pathInfo;
	}

    _handleReceivedEvent(serverResponse) {
		let path = false;
		let data = serverResponse.data ? serverResponse.data : {};
		let state = {
			parsed: data.data,
			isReloading: false,
			url: serverResponse.url,
			haveScreenData: data.screen_id ? true : false,
			screenInfo: data,
			operation: serverResponse.operation,
			initialized: true
		};

		switch (serverResponse.status) {
			case 'without-panel':
				path = urlMapping.getUrl("panel", "list-without-panel", {channelMappingDef_id: serverResponse.data.id, channelDef_id: serverResponse.data.channelDef_id});
				break;
            case 'channel-missing':
                path = urlMapping.getUrl("panel", "no-channel", this.getPathInfo(serverResponse));
				break;
            case 'no-screen':
                path = urlMapping.getUrl("panel", "no-screen", this.getPathInfo(serverResponse));
				break;
			case 'caching':
				path = urlMapping.getUrl("panel", "required-caching", this.getPathInfo(serverResponse));
				break;
            case 'loading-panel':
                path = urlMapping.getUrl("panel", "loading-panel", this.getPathInfo(serverResponse));
				break;
            case 'found':
				path = urlMapping.getUrl("panel", "panel", this.getURLObject(state));
				break;
			case 'error':
				state = {
					"parsed": null,
					url: null,
					isReloading: false,
					haveScreenData: false,
					initialized: true
				};
				path = urlMapping.getUrl("panel", "error");
				break;
			case 'no-data':
				state = {
					"parsed": null,
					url: serverResponse.url,
					isReloading: false,
					screenInfo: serverResponse.data,
					haveScreenData: false,
					initialized: true
				};

				path = urlMapping.getUrl("panel", "empty");
				break;
			default:
				console.log("Dativery: Unknown status", serverResponse);  // eslint-disable-line no-console

				state = {
                    "parsed": null,
                    isReloading: false,
                    haveScreenData: false,
					initialized: true
                };
				path = urlMapping.getUrl("panel", "error");
				break;
		}

		this.setState(state);

		console.log("Dativery: Development Panel URL", {path: path});  // eslint-disable-line no-console
		this.context.router.push(path);

    }

    receivedMessageListener = (event) => {
        let command = event.data;

        switch (command.msg) {
            case 'dativeryUrlChange':
                console.log("receivedMessageListener", command);  // eslint-disable-line no-console
                break;
            case 'dativeryStartingReload':
                this.setState({
                    isReloading: true
                });
                console.log("receivedMessageListener", command);  // eslint-disable-line no-console
                break;
            case 'dativeryLayoutChanged': {
                let changes = {};

                if (this.state.isInjected !== command.isInjected) {
                    changes['isInjected'] = command.isInjected;
                }
                if (this.state.orientation !== command.orientation) {
                    changes['orientation'] = command.orientation;
                }

                /* has anything interesting changed? */
                if (Object.keys(changes).length > 0) {
                    /* change state and redraw page */
                    this.setState(changes);
                }

            } break;
            case 'dativeryInvokeEventByURL':
            {
                console.log(command.msg, command.url, command);  // eslint-disable-line no-console
                if (!this.checkToken()) {
                    return;
                }

                fetch(window['config']['apiHost'] + '/handle-url?url=' + encodeURIComponent(command.url), {
                    headers: {
                        'Authorization': 'Bearer ' + Token.get()
                    }
                }).then((response) => {
                    return response.json();
                }).then((body) => {
                    this._handleReceivedEvent(body);
                }).catch((e) => {
                    displayError(e);
                });

            } break;
            case 'dativeryInvokeEventByDescription':
            {
                console.log(command.msg, command.data, command);  // eslint-disable-line no-console

				this.setState({
					app: command.data.app
				});

                if (!this.checkToken()) {
                    return;
                }

                fetch(window['config']['apiHost'] + '/handle-url?data=' + encodeURIComponent(JSON.stringify(command.data)), {
                    headers: {
                        'Authorization': 'Bearer ' + Token.get()
                    }
                }).then((response) => {
                    return response.json();
                }).then((body) => {
                    this._handleReceivedEvent(body);
                }).catch((e) => {
                    displayError(e);
                });

            } break;
            case 'dativeryInvokeEvent':
            {
                if (!this.checkToken()) {
                    return;
                }

                console.log(command.msg, command.serverResponse.status, command);  // eslint-disable-line no-console
                this._handleReceivedEvent(command.serverResponse);

            } break;
			case 'dativeryReloadFrame':
			{
				sendToExtension({
					message: 'dativery-reload',
				});
				window.location.reload();
			} break;
            case 'dativeryErrorFound':
            {
                if (!this.checkToken()) {
                    return;
                }

                console.log("dativeryErrorFound", command);  // eslint-disable-line no-console
                this.setState({
                    "parsed": null,
                    isReloading: false,
                    haveScreenData: false,
					initialized: true
                });

                let path = urlMapping.getUrl("panel", "error");
                this.context.router.push(path);

            } break;
            case 'dativeryInit':
                let target = parent.postMessage ? parent : (parent.document.postMessage ? parent.document : undefined);
           //     target.postMessage({msg: 'dativeryInitConfirm'}, "*");
                break;
			case 'dativeryParentWinResize':
				this.setState({
					parentWinHeight: command.height,
				});
				if (!this.fullscreen) {
					this.resizeY(this.state.panelHeight);
				}
				break;
        }
    };

    hideDativery = () => {
        sendMessage({msg: 'dativeryClose'});
    };

    reloadDativery = () => {
        /* reload Dativery page */
        return sendToExtension({
            message: 'dativery-reload-page',
            data: {},
        });
    };

    needFullScreenPanel() {
        if (this.fullscreen === false) {
            this.fullscreen = true;
            this.isOpen = false;
            sendMessage({msg: 'dativeryFullscreen'});
        }
    }

    minimizePanel() {
        sessionStorage['is-minimized-' + this.state.screen_id] = true;

		sendToExtension({
			message: 'dativery-minimalize',
			data: {
				screenId: this.getURLObject().screen_id
			}
		});
    }

    isMinimizedPanel() {
		return Boolean(sessionStorage['is-minimized-' + this.state.screen_id]);
    }

	setMinimalized(minimalized, screenId) {
		if (minimalized) {
			sessionStorage['is-minimized-' + screenId] = true;
		}
		else {
			delete sessionStorage['is-minimized-' + screenId];
		}
	}

    cancelMinimizePanel() {
        delete sessionStorage['is-minimized-' + this.state.screen_id];
		sendToExtension({
			message: 'dativery-maximalize',
			data: {
				screenId: this.state.screen_id
			}
		});
    }

    needRegularPanel() {
        if (this.fullscreen === true || this.isOpen === false) {
            this.fullscreen = false;
            this.isOpen = true;
			sendMessage({msg: 'dativeryRegularPanel'});
        }
    }

    ensureWeReloadData() {
        let si = immutable.fromJS(this.state.parsed);
        si = si.updateIn([0], (value) => {
            if (value) {
                return value.set('random', Math.floor((Math.random() * 1000) + 1));
            }
        });

        this.setState({
            parsed: si.toJS()
        });
    }

    resizeY(height) {
		let newHeight = height;

		if (this.state.parentWinHeight === 0) {
			this.setState({
				parentWinHeight: window.outerHeight
			});
		}
		let windowHeight = this.state.parentWinHeight * 0.6;

		if (newHeight > windowHeight) {
			if (windowHeight <= defaultPanelHeight) {
				newHeight = windowHeight;
			} else if (newHeight > defaultPanelHeight) {
				newHeight = windowHeight;
			}
		}

		if (height > 0) {
            this.setState({
                panelHeight: height,
            });

            sendMessage({msg: 'dativeryResize', height: newHeight});
        }
    }

    resizeX(width) {
        sendMessage({msg: 'dativeryResize', width: width});
    }

    resizeDefaultHeight(fullPanel) {
		if (fullPanel) {
			sendMessage({msg: 'dativeryResize', height: defaultPanelHeight});
		}
		else {
			sendMessage({msg: 'dativeryResize', height: defaultMiniPanelHeight});
		}
    }

    needMiniPanel(hasScreen, visibleTooltip) {
        if (window.config['stayInjected']) {
            this.needRegularPanel();
        } else {
            this.isOpen = false;
            this.fullscreen = false;
			if (hasScreen) {
				sendMessage({msg: 'dativeryMinimalizedPanel'});
			}
			else if (this.tooltip) {
				sendMessage({msg: visibleTooltip ? 'dativeryMiniPanelWithTooltipOpen' : 'dativeryMiniPanelWithTooltip'});
			}
			else {
				sendMessage({msg: 'dativeryMiniPanel'});
			}
        }
    }

    hadRegular() {
        return this.isOpen === true && this.fullscreen === false;
    }

    hadFullScreen() {
        return this.fullscreen === true;
    }

    screenCreated(screenId, redirectToEdit) : Promise {
        /* inform extension to reload screen cache */
        return sendToExtension({
            message: 'dativery-reload'
        }).then(() => {
            let screenInfo = {...this.state.screenInfo, screen_id: screenId};

            this.setState({
                screenInfo: screenInfo,
                haveScreenData: true,
				initialized: true
            });

            if (redirectToEdit) {
                let path = urlMapping.getUrl('panel', "screen-settings", screenInfo);
                this.context.router.push(path);
            } else {
                let path = urlMapping.getUrl('panel', "panel", this.getURLObject());
                this.context.router.push(path);
            }
        });
    }

    /**
     * called when screen has been removed
     */
    screenRemoved() {
		let self = this;
        return sendToExtension({
            message: 'dativery-reload',
			afterAction: 'dativery-reload-page'
        }).then(() => {
            let screenInfo = {...self.state.screenInfo, screen_id: null};

            self.setState({
                haveScreenData: false,
                screenInfo: screenInfo,
				initialized: true
            });

            let path = urlMapping.getUrl('panel', 'no-screen', self.getURLObject());
            self.context.router.push(path);
        });
    }

    menuDativery = () => {
        let path = urlMapping.getUrl("panel", "menu", this.getURLObject());
        this.context.router.push(path);
    };

    closeFullScreen = () => {
        let path = urlMapping.getUrl("panel", "panel", this.getURLObject());
        this.context.router.push(path);
    };

    componentDidMount() {

        /* add listener to listen on messages from outer iframe */

        /*eslint no-undef: 0*/
        if (window.addEventListener) {
            addEventListener("message", this.receivedMessageListener, false);
        } else {
            attachEvent("onmessage", this.receivedMessageListener);
        }

        sendMessage({msg: 'dativeryInitPanel'});
    }

    componentWillUnmount() {
        if (window.removeEventListener) {
            removeEventListener("message", this.receivedMessageListener);
        } else {
            detachEvent("onmessage", this.receivedMessageListener);
        }
    }

    render() {
		return (
			<div className={"panelWrapper" + (this.state.loggedOut ? ' loggedOut' : '') + (this.state.isInjected ? ' injected' : '')}>
				<LoadingLine inPanel />
				{this.props.children}
				{this.state.loggedOut ? (<LoggedOutMessage />) : null}
			</div>
		);
    }
}

export function lastPanelController() : EmbededPanelController {
    return lastPanelControllerInstance;
}
